import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Search, Check } from "lucide-react";
import { GoldButton } from "@/components/site/ui";
import { Input } from "@/components/ui/input";
import { api, inr } from "@/lib/api";
import { toast } from "sonner";
import { useSeo } from "@/lib/seo";

const STAGES = ["Order Received", "Requirement Discussion", "Information Received", "Work Started", "First Draft", "Revision", "Completed"];

export default function Track() {
    const { orderId } = useParams();
    const [id, setId] = useState(orderId || "");
    const [order, setOrder] = useState(null);
    useSeo({ title: "Track My Request | SUDIGI", description: "Track the status of your order and project with Sudigi." });

    const lookup = async (val) => {
        const q = (val || id).trim();
        if (!q) return;
        try { const { data } = await api.get(`/orders/track/${q}`); setOrder(data); }
        catch { toast.error("Order not found"); setOrder(null); }
    };
    useEffect(() => { if (orderId) lookup(orderId); /* eslint-disable-next-line */ }, [orderId]);

    const currentIdx = order ? Math.max(0, STAGES.indexOf(order.order_status)) : 0;

    return (
        <section className="bg-teal-900 py-16 min-h-[70vh]">
            <div className="container-x max-w-2xl">
                <h1 className="font-serif text-4xl text-cream text-center">Track My Request</h1>
                <p className="text-cream-soft text-center mt-3">Enter your Order ID to see your project status.</p>
                <div className="flex gap-2 mt-8">
                    <Input className="bg-teal-800/50 border-brandborder text-cream" placeholder="e.g. ORD12345678" value={id} onChange={(e) => setId(e.target.value)} data-testid="track-input" />
                    <GoldButton onClick={() => lookup()} data-testid="track-search-btn"><Search className="w-4 h-4" /> Track</GoldButton>
                </div>

                {order && (
                    <div className="card-teal rounded-2xl p-6 mt-8" data-testid="track-result">
                        <div className="flex justify-between items-start mb-6">
                            <div><div className="font-mono text-gold">{order.order_id}</div><div className="text-cream-soft text-sm mt-1">{[order.package, order.service].filter(Boolean).join(", ")}</div></div>
                            <div className="text-right"><div className="font-mono font-bold text-cream">{inr(order.amount)}</div><div className={`text-xs mt-1 ${order.payment_status === "Paid" ? "text-growth" : "text-gold"}`}>{order.payment_status}</div></div>
                        </div>
                        <div className="space-y-0">
                            {STAGES.map((s, i) => (
                                <div key={s} className="flex items-center gap-3 py-2">
                                    <div className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 ${i <= currentIdx ? "bg-growth text-teal-900" : "bg-teal-700 text-cream-soft/50"}`}>
                                        {i <= currentIdx ? <Check className="w-4 h-4" /> : i + 1}
                                    </div>
                                    <span className={`text-sm ${i <= currentIdx ? "text-cream font-medium" : "text-cream-soft/60"}`}>{s}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
